<template>
  <v-layout column v-if="compradores.length > 0">
    <div v-if="mostrarDescripcion && reserva.cod_tipo_operacion !== 'ALQ'">
      <o-medium-title>{{$t('reservas.comprador.descripcionOperacion')}}</o-medium-title>
      <v-radio-group hide-details value="compraventa" row class="fullWidth">
        <v-flex xs12 md4>
          <v-radio
            :label="$t('reservas.comprador.compraVenta')"
            value="compraventa"
            :disabled="true"
            color="primary"
          />
        </v-flex>
        <v-flex xs12 md4>
          <v-radio
            :label="$t('reservas.comprador.arrendamientoCompra')"
            value="arrendamiento"
            :disabled="true"
            color="primary"
          />
        </v-flex>
        <v-flex xs12 md4>
          <v-radio
            :label="$t('general.misc.otros')"
            value="otros"
            :disabled="true"
            color="primary"
          />
        </v-flex>
      </v-radio-group>
      <v-layout column mb-3 mt-3>
        <v-flex xs12>
          <v-text-field
            :disabled="true"
            :label="$t('reservas.comprador.promocion')"
            :value="promocion.descripcion + ' - ' + inmueble.descripcionLarga"
            hide-details
          />
        </v-flex>
        <v-flex xs12>
          <v-text-field
            :disabled="true"
            :label="$t('reservas.comprador.importeOperacion')"
            :value="$options.filters['currency'](totalImporte) + pintadoMasIVA"
            hide-details
          />
        </v-flex>
        <v-flex xs12>
          <v-text-field
            :disabled="true"
            :label="$t('reservas.comprador.importeReserva')"
            :value="reserva.importeReserva | currency"
            hide-details
          />
        </v-flex>
      </v-layout>
    </div>
    <div v-else-if="mostrarDescripcion && reserva.cod_tipo_operacion === 'ALQ'">
      <o-medium-title>{{$t('reservas.comprador.descripcionOperacion')}}</o-medium-title>
      <v-radio-group hide-details value="arrendamiento" row class="fullWidth">
        <v-flex xs12 md4>
          <v-radio
            :label="$t('reservas.comprador.compraVenta')"
            value="compraventa"
            :disabled="true"
            color="primary"
          />
        </v-flex>
        <v-flex xs12 md4>
          <v-radio
            :label="$t('reservas.comprador.arrendamiento')"
            value="arrendamiento"
            :disabled="true"
            color="primary"
          />
        </v-flex>
        <v-flex xs12 md4>
          <v-radio
            :label="$t('general.misc.otros')"
            value="otros"
            :disabled="true"
            color="primary"
          />
        </v-flex>
      </v-radio-group>
      <v-layout column mb-3 mt-3>
        <v-flex xs12>
          <v-text-field
            :disabled="true"
            :label="$t('reservas.comprador.promocion')"
            :value="promocion.descripcion + ' - ' + inmueble.descripcionLarga"
            hide-details
          />
        </v-flex>
        <v-flex xs12>
          <v-text-field
            :disabled="true"
            :label="$t('reservas.comprador.importeReserva')"
            :value="reserva.importeReserva | currency"
            hide-details
          />
        </v-flex>
      </v-layout>
    </div>
    <!-- eslint-disable-next-line -->
    <o-medium-title>
      {{
        $t('general.misc.datosDel', {
          comprador: reserva.cod_tipo_operacion === 'VTA' ? $t('reservas.comprador.comprador') : $t('reservas.comprador.arrendatario'),
          nombre: getTitular.nombre ? getTitular.nombre : ''
        })
      }}
    </o-medium-title>
    <v-radio-group
      v-if="!scoring"
      v-model="titularJuridico"
      hide-details
      :rules="[rules.requiredIf(guardarYEnviar)]"
      :disabled="readonly || datosYaRellenados"
      row
      class="fullWidth"
      @change="cambiarJuridicoTitular()"
    >
      <v-layout wrap justify-space-around>
        <v-radio
          :label="$t('promociones.fisico')"
          :value="false"
          color="primary"
        />
        <v-radio
          :label="$t('promociones.juridico')"
          :value="true"
          color="primary"
        />
      </v-layout>
    </v-radio-group>
    <KycCompradorFisico 
      v-if="!getTitular.juridico" 
      :comprador.sync="getTitular" 
      :bloquearCampos="datosYaRellenados"
      :revisando="revisando"
      :readonly="readonly"
      :fullKyc="tipo === 'kyc' || tipo == 'pbc' || tipo == 'validacionDocumentacion'"
      :incrustado="incrustado"
      :loading="waitingForLoad" 
      :cargandoExterior="cargandoExterior" 
      :waitingForLoad="waitingForLoad"
      :guardarYEnviar="guardarYEnviar"
    />
    <KycCompradorJuridico 
      v-else 
      :comprador.sync="getTitular" 
      :bloquearCampos="datosYaRellenados"
      :revisando="revisando"
      :readonly="readonly"
      :fullKyc="tipo === 'kyc' || tipo == 'pbc' || tipo == 'validacionDocumentacion'"
      :incrustado="incrustado" 
      :loading="waitingForLoad" 
      :cargandoExterior="cargandoExterior" 
      :waitingForLoad="waitingForLoad"
      :guardarYEnviar="guardarYEnviar"
    />
    <div v-if="getRestoCompradores.length > 0">
      <o-medium-title>{{$t('general.misc.otros')}} {{reserva.cod_tipo_operacion === 'VTA' ? $t('reservas.comprador.compradores') : $t('reservas.comprador.arrendatarios')}}</o-medium-title>
    </div>
    <v-expansion-panel 
      expand 
      v-model="expansionComputed" 
      :class="[
        'elevation-0', 
        'mt-2'
      ]"
      class="noPadding"
    >
      <v-expansion-panel-content
        class="comprador"
        v-for="(comprador, i) in getRestoCompradores"
        :key="'comprador'+i"
        expand-icon=""
      >
        <template slot="actions">
          <!-- eslint-disable-next-line -->
          <v-icon color="primary">{{comprador.juridico === null ? '' : '$vuetify.icons.expand'}}</v-icon>
          <v-btn
            v-if="!readonly && !datosYaRellenados && !scoring"
            icon
            class="mb-0"
            @click.stop="mostrarAvisoBorrar(i)"
          >
            <v-icon class="botonEliminar" medium color="primary">remove_circle_outline</v-icon>
          </v-btn>
        </template>
        <div slot="header">
          <o-medium-title-detail
            :error="!expansion[i] && !revisando && !compradorEstaValidado(comprador)"
            :details="$t('reservas.comprador.datosIncorrectos', {
              comprador: reserva.cod_tipo_operacion === 'VTA' ? $t('reservas.comprador.comprador') : $t('reservas.comprador.arrendatario')
            })"
          >
            {{
              $t('general.misc.datosDel', {
                comprador: reserva.cod_tipo_operacion === 'VTA' ? $t('reservas.comprador.comprador') : $t('reservas.comprador.arrendatario'),
                nombre: comprador.nombre ? comprador.nombre : i+2
              })
            }}
          </o-medium-title-detail>
        </div>
        <v-radio-group
          v-if="!scoring"
          v-model="comprador.juridico"
          hide-details
          :rules="[rules.requiredIf(guardarYEnviar)]"
          :disabled="readonly || datosYaRellenados"
          row
          class="fullWidth"
          @change="cambiarJuridicoComprador(i)"
        >
          <v-layout wrap justify-space-around>
            <v-radio
              :label="$t('promociones.fisico')"
              :value="false"
              color="primary"
            />
            <v-radio
              :label="$t('promociones.juridico')"
              :value="true"
              color="primary"
            />
          </v-layout>
        </v-radio-group>
        <KycCompradorFisico 
          v-if="comprador.juridico === false" 
          :comprador.sync="comprador" 
          :bloquearCampos="datosYaRellenados"
          :revisando="revisando"
          :readonly="readonly"
          :fullKyc="tipo === 'kyc' || tipo == 'pbc' || tipo == 'validacionDocumentacion'"
          :incrustado="incrustado"
          :loading="waitingForLoad" 
          :cargandoExterior="cargandoExterior" 
          :waitingForLoad="waitingForLoad"
          :guardarYEnviar="guardarYEnviar"
          :indice="i+1"
        />
        <KycCompradorJuridico 
          v-if="comprador.juridico === true" 
          :comprador.sync="comprador" 
          :bloquearCampos="datosYaRellenados"
          :revisando="revisando"
          :readonly="readonly"
          :fullKyc="tipo === 'kyc' || tipo == 'pbc' || tipo == 'validacionDocumentacion'"
          :incrustado="incrustado" 
          :loading="waitingForLoad" 
          :cargandoExterior="cargandoExterior" 
          :waitingForLoad="waitingForLoad"
          :guardarYEnviar="guardarYEnviar"
          :indice="i+1"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-layout my-3 v-if="!readonly && !datosYaRellenados && !scoring" key="add_comprador">
      <add-arrendatario
        :disabled="waitingForLoad || cargandoExterior"
        @addArrendatario="addComprador"
      >
        {{$t('general.misc.add')}} {{reserva.cod_tipo_operacion === 'VTA' ? $t('reservas.comprador.comprador') : $t('reservas.comprador.arrendatario')}}
      </add-arrendatario>
    </v-layout>
    <v-fade-transition>
      <custom-dialog v-if="mostrarBorrar" v-model="mostrarBorrar">
        <KycBorrar
          :description="descripcionBorrar(indiceBorrar)"
          :titulo="$t('reservas.comprador.eliminar') + (reserva.cod_tipo_operacion === 'VTA' ? $t('reservas.comprador.compradorMayuscula') : $t('reservas.comprador.arrendatarioMayuscula'))"
          @continuar="borrarComprador"
        />
      </custom-dialog>
    </v-fade-transition>
  </v-layout>
</template>
<script>
import { mapGetters } from 'vuex'
import KycCompradorFisico from '@/components/reservas/kyc/KycCompradorFisico'
import KycCompradorJuridico from '@/components/reservas/kyc/KycCompradorJuridico'
import KycBorrar from '@/components/reservas/kyc/KycBorrar'
import MixinComprador from '@/mixins/comprador'
import MixinEstadoKyc from '@/mixins/estadosReserva/estadoKyc'
import MixinEstadoContrato from '@/mixins/estadosReserva/estadoContrato'
import MixinEstadoValidacionDocumentacion from '@/mixins/estadosReserva/estadoValidacionDocumentacion'
import rules from '@/mixins/rules'

export default {
  mixins: [
    rules,
    MixinComprador,
    MixinEstadoKyc,
    MixinEstadoContrato,
    MixinEstadoValidacionDocumentacion
  ],
  props: {
    incrustado: {
      type: Boolean,
      default: false
    },
    cargandoExterior: {
      type: Boolean,
      default: false
    },
    waitingForLoad: {
      type: Boolean,
      default: false
    },
    mostrarDescripcion: {
      type: Boolean,
      default: true
    },
    tipo: {
      type: String,
      default: 'kyc'
    },
    compradores: {
      type: Array,
      default: () => []
    },
    expansion: {
      type: Array,
      default: () => []
    },
    guardarYEnviar: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      mostrarBorrar: false,
      indiceBorrar: -1,
      montado: false
    }
  },
  mounted () {
    // Hacemos ñapa porque la transicion de OTROS COMPRADORES si carga de primeras no funciona
    this.montado = true
  },
  components: {
    KycCompradorFisico,
    KycCompradorJuridico,
    KycBorrar
  },
  computed: {
    ...mapGetters({
      usuario: 'login/usuario',
      inmuebles: 'promociones/inmuebles/getAll',
      promociones: 'promociones/getAll',
      reserva: 'reservas/_id/getActual',
      tarifa: 'reservas/_id/tarifas/getActual',
      moduloOrden: 'modulosOrdenes/getActual'
    }),
    scoring () {
      return this.moduloOrden.scoring
    },
    expansionComputed: {
      get () {
        return this.expansion
      },
      set (val) {
        val.forEach((x, index) => {
          this.$set(this.expansion, index, val[index])
        })
      }
    },
    titularJuridico: {
      get () {
        return this.getTitular.juridico
      },
      set (val) {
        const index = this.compradores.findIndex(x => x.titular)
        if (index !== -1) {
          this.compradores[index].juridico = val
        }
      }
    },
    iva () {
      return this.tarifa.iva == null ? 0 : this.tarifa.iva
    },
    pintadoMasIVA () {
      return this.iva === 0 ? '' : ' (+IVA)'
    },
    inmueble () {
      return this.inmuebles[0]
    },
    promocion () {
      return this.promociones[0]
    },
    totalImporte () {
      return this.tarifa.importeTotalConHijos
    },
    datosYaRellenados () {
      if (this.tipo === 'kyc') {
        return this.reserva.estadoContrato.codigoEstadoContrato !== 1
      } else if (this.tipo === 'contrato') {
        return this.reserva.estadoKyc.codigoEstadoKyc !== 1
      } else {
        return false
      }
    },
    revisando () {
      switch (this.tipo) {
        case 'validacionDocumentacion':
          return this.validacionEnRevision
        case 'kyc':
        case 'contrato':
        case 'pbc':
          return false
        default:
          console.log(this.$t('reservas.comprador.tipoIncorrecto'))
          return false
      }
    },
    readonly () {
      switch (this.tipo) {
        case 'kyc':
          return this.kycReadonly
        case 'contrato':
          return this.contratoReadonly
        case 'pbc':
          return true
        case 'validacionDocumentacion':
          return true
        default:
          console.log(this.$t('reservas.comprador.tipoIncorrecto'))
          return false
      }
    }
  },
  methods: {
    descripcionBorrar (indiceBorrar) {
      return this.$t(
        (this.reserva.cod_tipo_operacion === 'VTA' ? 'reservas.kyc.confirmacionEliminarComprador' : 'reservas.kyc.confirmacionEliminarArrendatario'),
        {
          nombre: this.getRestoCompradores[indiceBorrar].nombre ? '"' + this.getRestoCompradores[indiceBorrar].nombre + '"' : indiceBorrar + 2
        }
      )
    },
    mostrarAvisoBorrar (i) {
      this.indiceBorrar = i
      this.mostrarBorrar = true
    },
    borrarComprador () {
      this.mostrarBorrar = false
      this.compradores.splice(this.compradores.indexOf(this.getRestoCompradores[this.indiceBorrar]), 1)
      this.indiceBorrar = -1
    },
    cambiarJuridicoComprador(index) {
      if (this.getRestoCompradores[index].juridico) {
        this.getRestoCompradores[index].tipoDocumentoID = 'C'
      } else if (this.getRestoCompradores[index].tipoDocumentoID === 'C') {
        this.getRestoCompradores[index].tipoDocumentoID = null
      }
    },
    cambiarJuridicoTitular() {
      if (this.getTitular.juridico) {
        this.getTitular.tipoDocumentoID = 'C'
      } else if (this.getTitular.tipoDocumentoID === 'C') {
        this.getTitular.tipoDocumentoID = null
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/reservas/comprador/BaseKyc.vue